import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Select } from '../models/select';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class DistributionCentersService extends BaseService {

  constructor(private http: HttpClient) { super(); }

  getCombo(): Observable<Select[]> {
    return this.http.get<Select[]>(`${this.getUrl('DistributionCenters/GetCombo/')}`);
  }

  getComboExtended(): Observable<Select[]> {
    return this.http.get<Select[]>(`${this.getUrl('DistributionCenters/GetComboExtended/')}`);
  }

  setDeliveryLimit(id: number, days: number): Observable<any> {
    return this.http.get(`${this.getUrl('DistributionCenters')}/${id}/DeliveryLimit/${days}`);
  }
}
